export const LOG_ACTIONS = {
  LOGIN: 'Login',
  SEARCH: 'Search',
  CHAT_OPEN_CLOSE: 'Chat_open_close',
  CHAT: 'Chat',
  FILTER: 'Filter',
  AUDIT_FILTER: 'Audit Filter',
  SOURCE_CHANGE: 'source_change',
  DRAWER: 'drawer_open',
  TOGGLE_CHART: 'Toggle_chart',
  DYNAMIC_DASHBOARD_OPEN: 'Dynamic Dashboard',
  AUDIT_DASHBOARD_OPEN: 'Audit Dashboard',
  UPLOAD_FILE: 'File Upload',
  FEEDBACK: 'Feedback',
} as const;
